import React, {Fragment, useEffect, useState} from "react";
import queryString from 'query-string'
import {useLocation} from 'react-router-dom'

import './TeamDashboardTab.scss';
import DashboardPanelTeamChildAge from "root/dashboard/DashboardPanelTeamChildAge";
import DashboardPanelTeamPosts from "root/dashboard/DashboardPanelTeamPosts";
import DashboardPanelTeamMessages from "root/dashboard/DashboardPanelTeamMessages";
import DashboardPanelTeamLogins from "root/dashboard/DashboardPanelTeamLogins";
import DashboardPanelTeamChildrenDiary from "root/dashboard/DashboardPanelTeamChildrenDiary";
import {UserTypes} from "root/DataFunctions/Constants";
import {getMonthName} from "root/DataFunctions/DashboardDataFns"
import {useSetRecoilState} from "recoil";
import {teamNameAtom} from "root/recoil/teamName";
import {getTeamDetails} from "root/DataFunctions/TeamDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import DashboardPanelOrgUsers from "root/dashboard/DashboardPanelOrgUsers";
import phpVars from 'phpVars';

const TeamDashboardTab = (props) =>
{
    const d = new Date();
    const currentMonth = d.getMonth();
    const currentYear = d.getFullYear();

    const [month, setMonth] = useState(currentMonth);
    const [year, setYear] = useState(currentYear);

    const {search} = useLocation()

    const queryParams = queryString.parse(search);

    const displayPanel = () =>
    {
        const has_lifestory = phpVars.has_lifestory === 1 ? true :false;

        switch (queryParams.type)
        {
            case 'child-posts':
                return <DashboardPanelTeamPosts team_id={props.team_id} user_type={UserTypes.CHILD} title={'Child Posts'} year={year} month={month+1}/>
                break;

            case 'child-messages':
                return <DashboardPanelTeamMessages team_id={props.team_id} user_type={UserTypes.CHILD} title={'Child Messages'} year={year} month={month+1}/>
                break;

            case 'staff-messages':
                return <DashboardPanelTeamMessages team_id={props.team_id} user_type={null} title={'Staff Messages'} year={year} month={month+1}/>
                break;

            case 'all-messages':
                return <DashboardPanelTeamMessages team_id={props.team_id} user_type={UserTypes.ALL} title={'All Messages'} year={year} month={month+1}/>
                break;

            case 'child-logins':
                return <DashboardPanelTeamLogins team_id={props.team_id} user_type={UserTypes.CHILD} title={'Child Logins'} year={year} month={month+1}/>
                break;

            case 'child-diary':
                return <DashboardPanelTeamChildrenDiary team_id={props.team_id} title={'Child Diary Entries'} year={year} month={month+1}/>
                break;

            case 'staff-logins':
                return <DashboardPanelTeamLogins team_id={props.team_id} user_type={null} title={'Staff Logins'} year={year} month={month+1}/>
                break;

            case 'all-logins':
                return <DashboardPanelTeamLogins team_id={props.team_id} user_type={UserTypes.ALL} title={'All Logins'} year={year} month={month+1}/>
                break;

            case 'staff-posts':
                return <DashboardPanelTeamPosts team_id={props.team_id} user_type={null} title={'Staff Posts'} year={year} month={month+1}/>
                break;

            case 'all-posts':
                return <DashboardPanelTeamPosts team_id={props.team_id} user_type={UserTypes.ALL} title={'All Posts'} year={year} month={month+1}/>
                break;

            case 'child-age':
                return <DashboardPanelTeamChildAge team_id={props.team_id} title={'Number of Children In Age Range'}/>
                break;

            case 'users':
                return <DashboardPanelOrgUsers title={'Users by Type'} team_id={props.team_id} />
                break;

            default:
                if(has_lifestory){
                    return <DashboardPanelTeamPosts team_id={props.team_id} user_type={UserTypes.CHILD} title={'Child Posts'} year={year} month={month+1}/>
                }
                else{
                    return <DashboardPanelTeamMessages team_id={props.team_id} user_type={UserTypes.CHILD} title={'Child Messages'} year={year} month={month+1}/>
                }

                break;
        }
    }

    //Get child's data and set the global child name used by the various body header
    const setTeamName = useSetRecoilState(teamNameAtom);

    useEffect(() => {
        getTeamData();
    }, [props.team_id]);

    const getTeamData = () =>{
        getTeamDetails(props.team_id, (response) =>
        {
            let teamData = getDataFromResponse(response)[0];
            // Set the recoil childNameAtom to the first child
            setTeamName({ name: teamData.team_name, filter: 'Dashboard' });
        });
    }

    const onClickPrevious = () =>
    {
        if(month == 0){
            setMonth(11);
            setYear(curYear=> curYear - 1);
        }
        else{
            setMonth(curMonth=> curMonth - 1);
        }
    }

    const onClickNext = () =>
    {
        if(month == 11){
            setMonth(0);
            setYear(curYear=> curYear + 1);
        }
        else{
            setMonth(curMonth=> curMonth + 1);
        }
    }

    const displayDateString = () =>{
        let monthName = getMonthName(month);
        let monthString = monthName + ' ' + year;
        return <div>{monthString}</div>
    }

    return (
        <Fragment>
            <div className="family-body">
                {displayPanel()}
            </div>

            {/* Month Buttons*/}
            {queryParams.type !== 'child-age' &&
                <div className="d-flex flex-row justify-content-end">
                    <div className="family-body">
                        {displayDateString()}
                    </div>

                    <div className="p-2">
                        <button onClick={onClickPrevious} className="btn btn-primary">-<i
                            className="et-arrow-bold-left"></i></button>
                    </div>
                    <div className="p-2">
                        <button onClick={onClickNext} className="btn btn-primary">+<i
                            className="et-arrow-bold-left"></i></button>
                    </div>
                </div>
            }
        </Fragment>
    )
}

TeamDashboardTab.defaultProps = {};

export default TeamDashboardTab;


